module.exports = __webpack_public_path__ + "img/solutions_2.8099ee42.svg";